var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wang_editor"},[_c('div',{ref:"toolbar",staticClass:"wang_toolbar"}),_c('div',{ref:"editor",staticClass:"wang_text"})])
}
var staticRenderFns = []

export { render, staticRenderFns }